import { adminPerms, securityErrorMessage } from "~/presentation/security/SecurePaths";
import { apiURL } from "../../usecases/api";
import { hasPermission } from "~/presentation/security/SecurityPath";

export class ApiExplanatoryVideoCategoryUseCases {
  constructor(httpClient) {
    this.httpClient = httpClient;
  }

  async getCategories({ checkPermission = false } = {}) {
    if (checkPermission) {
      if (!hasPermission([adminPerms.seeExplanatoryVideoCategory])) {
        return new Error(securityErrorMessage("visualizar categorias de vídeo explicativo."));
      }
    }

    try {
      const response = await this.httpClient.request({
        url: `${apiURL}/ExplanatoryVideoCategory`,
        method: "GET",
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data || error.message);
    }
  }

  async getCategoriesByRoute(route) {
    try {
      const encodedRoute = encodeURIComponent(route);
      const response = await this.httpClient.request({
        url: `${apiURL}/ExplanatoryVideoCategory/help?route=${encodedRoute}`,
        method: "GET",
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data || error.message);
    }
  }

  async getCategoryById(id) {
    if (!hasPermission([adminPerms.seeExplanatoryVideoCategory])) {
      return new Error(securityErrorMessage("visualizar categorias de vídeo explicativo."));
    }

    try {
      const response = await this.httpClient.request({
        url: `${apiURL}/ExplanatoryVideoCategory/${id}`,
        method: "GET",
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data || error.message);
    }
  }

  async createCategory(data) {
    if (!hasPermission([adminPerms.addExplanatoryVideoCategory])) {
      return new Error(securityErrorMessage("criar categorias de vídeo explicativo."));
    }

    try {
      const response = await this.httpClient.request({
        url: `${apiURL}/ExplanatoryVideoCategory`,
        method: "POST",
        data,
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data || error.message);
    }
  }

  async updateCategory(data) {
    if (!hasPermission([adminPerms.editExplanatoryVideoCategory])) {
      return new Error(securityErrorMessage("editar categorias de vídeo explicativo."));
    }

    try {
      const response = await this.httpClient.request({
        url: `${apiURL}/ExplanatoryVideoCategory`,
        method: "PUT",
        data,
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data || error.message);
    }
  }

  async deleteCategory(id) {
    if (!hasPermission([adminPerms.deleteExplanatoryVideoCategory])) {
      return new Error(securityErrorMessage("excluir categorias de vídeo explicativo."));
    }

    try {
      const response = await this.httpClient.request({
        url: `${apiURL}/ExplanatoryVideoCategory/${id}`,
        method: "DELETE",
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data || error.message);
    }
  }
}
